// src/local.ts
// API Base URL — dari env variable REACT_APP_API_BASE_URL, fallback ke local dev
// Production: set REACT_APP_API_BASE_URL di .env.production atau env server
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api';

export const DEFAULT_PAGINATION = {
  start: 0,
  limit: 10,
};

/**
 * Helper: ambil branch_id aktif dari localStorage (disimpan oleh BranchContext).
 * Returns nilai branch_id atau null.
 */
export function getActiveBranchId(): string | null {
  try {
    const stored = localStorage.getItem('activeBranch');
    if (!stored) return null;
    const branch = JSON.parse(stored);
    return branch.id ? String(branch.id) : null;
  } catch {
    return null;
  }
}

/**
 * Helper: return `&branch_id=X` buat ditambahkan ke URL API.
 * Returns empty string kalo gak ada branch aktif.
 */
export function getBranchQueryParam(): string {
  const id = getActiveBranchId();
  return id ? `&branch_id=${id}` : '';
}

/**
 * Helper: cek apakah user login punya role read-only (audit).
 * Diset saat login dari response user.is_read_only.
 * Role read-only cuma boleh baca (GET), semua aksi tulis disembunyikan.
 */
export function isReadOnly(): boolean {
  try {
    return localStorage.getItem('is_read_only') === 'true';
  } catch {
    return false;
  }
}